import { Link } from "react-router-dom";

const ShopProductCard = ({ productId, coverImage, title, price }) => {
    return (
        <div className="flex flex-col w-full md:w-[240px] rounded-xl overflow-hidden transition-transform duration-500 ease-in-out transform md:hover:scale-105 cursor-pointer">

            {/* Photo cover */}
            <div className="w-full h-[300px] md:h-[200px] overflow-hidden">
                {coverImage && <img src={coverImage} alt={title} className="object-cover w-full h-full rounded-xl" />}
                {/* Questi overlay andrebbero sostituiti con uno stop alla propagazione del click su Likeelement */}
                <Link to={`/product-details?productId=${productId}`}><div className="absolute top-0 right-0 bottom-8 left-0"></div>
                    <div className="absolute top-0 right-8 bottom-0 left-0"></div></Link>
            </div>

            {/* Info */}
            <Link to={`/product-details?productId=${productId}`}><div className="flex flex-col gap-2 p-2">
                {/* Title */}
                <h3 className="leading-tight text-neutral-700">{title}</h3>
                {/* Price */}
                <h4 className="text-[#225424] mt-[-10px]">{parseFloat(price).toFixed(2)}</h4>

            </div></Link>

        </div >
    )
}

export default ShopProductCard;